var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9545 7.46687C2.00228 4.15979 4.71811 1.5 8.05323 1.5C10.2588 1.5 12.192 2.66285 13.2629 4.40481C13.4075 4.64005 13.3341 4.94799 13.0988 5.09261C12.8636 5.23723 12.5556 5.16377 12.411 4.92853C11.5158 3.4723 9.89958 2.5 8.05323 2.5C5.26365 2.5 3.00313 4.71847 2.95465 7.46545L3.22157 7.20062C3.4176 7.00612 3.73418 7.00737 3.92867 7.20339C4.12317 7.39942 4.12192 7.716 3.92589 7.9105L2.80602 9.02161C2.61108 9.21502 2.29664 9.21502 2.1017 9.02161L0.981823 7.9105C0.785795 7.716 0.784551 7.39942 0.979045 7.20339C1.17354 7.00737 1.49012 7.00612 1.68615 7.20062L1.9545 7.46687ZM13.1916 6.97772C13.3864 6.7852 13.6998 6.7852 13.8946 6.97772L15.0187 8.08883C15.2151 8.28295 15.217 8.59953 15.0229 8.79593C14.8287 8.99233 14.5122 8.99417 14.3158 8.80005L14.0425 8.52996C13.9962 11.8402 11.2684 14.5 7.92231 14.5C5.70984 14.5 3.76986 13.338 2.69478 11.5959C2.54976 11.3609 2.6227 11.0529 2.85769 10.9078C3.09269 10.7628 3.40076 10.8358 3.54578 11.0707C4.44438 12.5269 6.06731 13.5 7.92231 13.5C10.7265 13.5 12.9954 11.278 13.0423 8.53128L12.7704 8.80005C12.574 8.99417 12.2574 8.99233 12.0633 8.79593C11.8692 8.59953 11.871 8.28295 12.0674 8.08883L13.1916 6.97772Z",
    fill: "#1A1B1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecheckIcon);
export default __webpack_public_path__ + "static/media/recheckIcon.d2c19e1a87da040180ba54e6d7c0ec10.svg";
export { ForwardRef as ReactComponent };